"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2968],{

/***/ 427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38305);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    fullParagraph: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].fullParagraph */ .Z.fullParagraph), {
        topic: {
            text: "For the creative process",
            color: "brand-blue"
        },
        title: "Streamline your creative workflow",
        body: "Use customizable forms to request all the information needed. Then, easily share assets and receive feedback in real time."
    }),
    asset: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].asset */ .Z.asset), {
        image: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].asset.image */ .Z.asset.image), {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
        })
    })
}));


/***/ }),

/***/ 32968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TwoThirdsTextAndAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.scss.js

var StyledTwoThirdsTextAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emxkgw60"
})(".side-by-side-text-and-asset-component{.side-by-side-content{.full-paragraph-component-wrapper{width:40%;}.image-wrapper{width:60%;}&.no-text-component{justify-content:center;.image-wrapper{width:100%;}}}}");

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/default-props.js
var default_props = __webpack_require__(427);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var TwoThirdsTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TwoThirdsTextAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TwoThirdsTextAndAssetComponent);
    function TwoThirdsTextAndAssetComponent() {
        (0,_class_call_check/* default */.Z)(this, TwoThirdsTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TwoThirdsTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwoThirdsTextAndAssetComponent, {
                    className: "two-thirds-text-and-asset-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], _object_spread({}, this.props))
                });
            }
        }
    ]);
    return TwoThirdsTextAndAssetComponent;
}(react.PureComponent);

TwoThirdsTextAndAssetComponent.defaultProps = default_props/* default */.Z;


/***/ })

}]);